import { ApexCodeHighlight } from '@periscopes/general/apex-classes';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeTablessContent } from '@periscopes/general';
import React from 'react';
import { useApiResource } from '@hooks';
export const ApexTriggerCodeTab = ({ index, sonarObjectId }) => {
    var _a;
    const targetUri = `v3/salesforce/apex-triggers/${sonarObjectId}/highlights`;
    const { resource, loading } = useApiResource(targetUri);
    if (loading) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    const spans = (_a = resource === null || resource === void 0 ? void 0 : resource.spans) !== null && _a !== void 0 ? _a : [];
    return (React.createElement(PeriscopeTablessContent, null,
        React.createElement(ApexCodeHighlight, { index: index, spans: spans })));
};
